import axios from 'utils/axios';
import type {
    GetLeadCounterResultType,
    GetLeadListResultType,
    LeadCreateDataType,
    LeadCloudFileType,
    LeadDetailsType,
    LeadEventAddDataType,
} from '@econtractor/types';
import { getCloudflareUploadUrls as getCloudflareUploadUrlsGeneric, type CloudUploadFileMeta } from './apiCloudflare';

export interface LeadListParams {
    page?: number;
    onPage?: number;
    search?: string;
    order?: string;
    status?: number[] | null;
}

export const getList = async (getData: LeadListParams): Promise<GetLeadListResultType | null> => {
    try {
        const response = await axios('/leads', { params: getData });
        return response?.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const getLead = async (leadId: number | string): Promise<LeadDetailsType | null> => {
    try {
        const response = await axios(`/leads/${leadId}`);
        return response?.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const getCounter = async (): Promise<GetLeadCounterResultType | null> => {
    try {
        const response = await axios('/leads/counter');
        return response.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const addEvent = async (leadId: number | string, eventData: LeadEventAddDataType): Promise<boolean> => {
    try {
        const response = await axios.post(`/leads/event/${leadId}`, eventData);
        return response.data?.stat || false;
    } catch (e) {
        console.error(e);
        return false;
    }
};

export const getCloudflareUploadUrls = async (
    leadId: number | string,
    files: CloudUploadFileMeta[],
): Promise<LeadCloudFileType[] | null> =>
    getCloudflareUploadUrlsGeneric(files, { leadId: Number(leadId || 0) });

export const publicEvent = async (eventId: number | string, eventPublic: boolean): Promise<boolean> => {
    try {
        const response = await axios.post(`/leads/event/public/${eventId}`, { eventPublic });
        return response.data?.stat || false;
    } catch (e) {
        console.error(e);
        return false;
    }
};

export const createLead = async (createData: LeadCreateDataType): Promise<number | false> => {
    try {
        const response = await axios.post('/leads/new', createData);
        return response.data?.leadId || false;
    } catch (e) {
        console.error(e);
        return false;
    }
};

export const deleteLead = async (leadId: number | string): Promise<boolean> => {
    try {
        const response = await axios.delete(`/leads/${leadId}`);
        return response.data?.stat || false;
    } catch (e) {
        console.error(e);
        return false;
    }
};
